export enum stickyBottomBarVariantsMap {
  "option-1" = "basic",
  "option-2" = "ahPlus",
}
